import { Link, Tooltip, FormControlLabel, Switch, Box } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../../interceptors/AxiosInterceptor";
import { AUTH_SECURE_USER_DETAILS_LS_LEY } from "../../edvenswa.emportal.auth/constants/Constants";
import GenericTable from "../../edvenswa.emportal.common/pages/GenericTable";
import { USER_RATINGS } from "../../edvenswa.emportal.common/constant";

const UserScreenAppraisal = (props) => {
  const user = JSON.parse(
    sessionStorage.getItem(AUTH_SECURE_USER_DETAILS_LS_LEY)
  );
  const location = useLocation();
  const [filteredElements, setFilteredElements] = useState([]);
  const [title, setTitle] = useState("");
  const [startDate, setStartDate] = useState(
    props.user.roles[0] === "Admin"
      ? location.state.startDate
      : moment(new Date()).startOf("month").format("DD-MM-YYYY")
  );
  const [endDate, setEndDate] = useState(
    props.user.roles[0] === "Admin"
      ? location.state.endDate
      : moment(new Date()).endOf("month").format("DD-MM-YYYY")
  );
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const ModifiedStartDate = moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD");
  const ModifiedEndDate = moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD");
  
  const [allRatings, setAllRatings] = useState([]); // store both individual+combined
  const [showCombined, setShowCombined] = useState(false); // toggle state
  const [showToggle, setShowToggle] = useState(false); // control toggle visibility

  const CustomNameComponent = (props) => {
    const { firstname, lastname, associateId } = props.data;
    return (
      <Tooltip title="User Overview">
        <Link
          sx={{ cursor: "pointer" }}
          underline="hover"
          onClick={() => {
            setTitle(`${firstname} ${lastname}`);
            navigate("/home/ratings/UserAppraisalForm", {
              state: {
                projectManager: props?.data?.projectManager,
                type: "User",
                astId: associateId,
                fullname: `${props.data.firstname} ${props.data.lastname}`,
                username: `${props.data.username}`,
                project: props.data.project,
                ratings: JSON.parse(props.data.ratingsObj),
                comments: props.data.comments,
                startDate: moment(props.data.startDate, "YYYY,MM,DD").format(
                  "YYYY-MM-DD"
                ),
                endDate: moment(props.data.endDate, "YYYY,MM,DD").format(
                  "YYYY-MM-DD"
                ),
              },
            });
          }}
        >
          {firstname} {lastname}
        </Link>
      </Tooltip>
    );
  };

  const calculateRatingAverage = (props) => {
    return <>{Math.floor(props.data.ratings * 100) / 100}</>;
  };

  const columnDefs = [
    {
      field: "associateId",
      headerName: "Ast ID",
      type: "number",
      cellStyle: { textAlign: "right" },
      // valueGetter: (params) =>
      //     params?.data?.user ? params?.data?.user?.associateId : "",
      flex: 0.5,
    },
    {
      headerName: "Associate Name",
      filter: true,
      cellRenderer: CustomNameComponent,
      width: 200,
    },
    {
      field: "projectManager",
      headerName: "Manager Name",
      type: "text",
      filter: true,
      flex: 0.8,
      valueGetter: (params) => {
        const manager = params.data?.projectManager;
        if (manager?.fullname) {
          return manager.fullname;
        }
        if (manager?.firstname && manager?.lastname) {
          return `${manager.firstname} ${manager.lastname}`;
        }
        return manager?.username || "Select Project Manager";
      },
      cellRenderer: (params) => {
        const rating = parseFloat(params.data?.ratings);
        const content = params.value;

        return rating === 0 && content === "Select Project Manager" ? (
          <Tooltip title="Click on Associate name">
            {content}
          </Tooltip>
        ) : (
          content
        );
      }
    },
    // {
    //   field: "project",
    //   headerName: "Project Name",
    //   type: "text",
    //   filter: true,
    //   flex: 0.8,
    //   valueGetter: (params) => {
    //     return params.data?.project ||
    //       params.data?.projectTitles ||
    //       "Select Project";
    //   },  
    //   cellRenderer: (params) => {
    //     const rating = parseFloat(params.data?.ratings);
    //     const content = params.value;
    //     const shouldShowTooltip = rating === 0 &&
    //       (content === "Select Project" || content === null);

    //     return shouldShowTooltip ? (
    //       <Tooltip title="Click on Associate name">
    //         {content || "Select Project"}
    //       </Tooltip>
    //     ) : (
    //       content || "No Project Assigned"
    //     );
    //   }
    // },
    {
      field: "startDate",
      headerName: "Start Date",
      type: "text",
      valueFormatter: (startDate) =>
        moment(startDate.value, "YYYY,MM,DD").format("DD-MMM-YYYY"),
      flex: 0.5,
    },
    {
      field: "endDate",
      headerName: "End Date",
      type: "text",
      valueFormatter: (startDate) =>
        moment(startDate.value, "YYYY,MM,DD").format("DD-MMM-YYYY"),
      flex: 0.5,
    },
    {
      field: "comments",
      headerName: "Comments",
      type: "text",
      flex: 1,
      valueGetter: (params) =>
        params.data.comments ? params.data.comments : "No Feedback Available",
      cellRenderer: (params) => {
        const rawComment = params.value || "No Feedback Available";

        const commentParts = rawComment.split(/\n+/).flatMap((line, index) => {
          const match = line.match(/^(.+?):$/); 
          if (match) {
            return [
              <div key={`mgr-${index}`}>
                <span style={{ fontWeight: "bold", fontFamily: "lucida console", color: "yellow", letterSpacing: "0.5px" }}>
                  {match[1]}:
                </span>
              </div>,
              <div key={`spacer-${index}`} style={{ height: '8px' }}></div> 
            ];
          }
          return <div key={`line-${index}`}>{line}</div>;
        });

        return (
          <Tooltip
            title={<React.Fragment>{commentParts}</React.Fragment>}
            placement="left"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: 400,
                  backgroundColor: "teal",
                  color: "white",
                  border: "1px solid #26a69a",
                  backdropFilter: "blur(10px)",
                  borderRadius: "10px",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                  padding: "12px",
                  fontFamily: "lucida console",
                  fontSize: "14px",
                  whiteSpace: "normal",
                  textAlign: "left",
                },
              },
            }}
          >
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                cursor: "pointer",
              }}
            >
              {rawComment.includes(":") ? rawComment.split(":")[0] + ":" : rawComment}
            </div>
          </Tooltip>
        );
      }

    },
    {
      field: "ratings",
      headerName: "PERF Rating",
      cellEditorPopup: true,
      filter: true,
      cellStyle: { textAlign: "right" },
      cellRenderer: calculateRatingAverage,
      flex: 0.5,
    },
  ];

  let sD1 = moment(ModifiedStartDate).startOf("month").format("YYYY-MM-DD");
  let eD1 = moment(sD1).startOf("month").add(14, "days").format("YYYY-MM-DD");
  let sD2 = moment(ModifiedStartDate)
    .startOf("month")
    .add(15, "day")
    .format("YYYY-MM-DD");
  let eD2 = moment(sD2).endOf("month").format("YYYY-MM-DD");
  let firstBiweeklyObj = {
    associateId: user?.associateId,
    comments: null,
    ratingsObj: null,
    username: null,
    firstname: `${user.firstname}`,
    lastname: `${user.lastname}`,
    project: "Select Project",
    projectManager: {
      associateId: 1065,
      username: "----",
      fullname: "Select Project Manager",
      firstname: null,
      lastname: null,
      dateOfJoining: null,
      dateOfBirth: null,
      designation: null,
      status: null,
      logo: null,
      mobile: null,
      roleId: null,
      tenant: null,
      email: null,
      projects: null,
      lastLoginTimeStamp: null,
      projectTitles: null,
      role: null,
    },
    ratings: 2.5,
    score: 0.0,
    "Associate Name": `${user.firstname} ${user.lastname}`,
    startDate: sD1,
    endDate: eD1,
    ratings: 0,
  };
  let secondBiweeklyObj = {
    associateId: user?.associateId,
    comments: null,
    ratingsObj: null,
    username: null,
    firstname: `${user.firstname}`,
    lastname: `${user.lastname}`,
    project: "Select Project",
    projectManager: {
      associateId: 1065,
      username: "sasikala@edvenswatech.com",
      fullname: "Select Project Manager",
      firstname: null,
      lastname: null,
      dateOfJoining: null,
      dateOfBirth: null,
      designation: null,
      status: null,
      logo: null,
      mobile: null,
      roleId: null,
      tenant: null,
      email: null,
      projects: null,
      lastLoginTimeStamp: null,
      projectTitles: null,
      role: null,
    },
    ratings: 2.5,
    score: 0.0,
    "Associate Name": `${user.firstname} ${user.lastname}`,
    startDate: sD2,
    endDate: eD2,
    ratings: 0,
  };
  
  useEffect(() => {
    setShowCombined(false);
    setLoading(true);
    props?.setType(USER_RATINGS);
    axiosInstance
      .put("/user/getRatingsByUser", {
        startDate: ModifiedStartDate,
        user: { username: location?.state?.username ?? user?.username },
        endDate: ModifiedEndDate,
      })
      .then((res) => {
        if (
          location.state &&
          (user.roles[0] === "Admin" ||
            (user.roles[0] === "Project Manager" &&
              user.username !== location.state.username))
        ) {
          // Process individual ratings
          const individual = res.data.map(item => ({
            ...item,
            projectManager: {
              ...item.projectManager,
              fullname: item.projectManager?.fullname || 
                       (item.projectManager?.firstname && item.projectManager?.lastname 
                         ? `${item.projectManager.firstname} ${item.projectManager.lastname}` 
                         : item.projectManager?.username || "Select Project Manager")
            }
          }));

          console.log(res.data, "res.data");
          console.log(individual, "individual ratings");

          // Process combined ratings
          const periodGroups = {};
          individual.forEach((entry) => {
            const periodKey = entry.startDate;
            if (!periodGroups[periodKey]) {
              periodGroups[periodKey] = {
                entries: [],
                managers: new Set(),
                projects: new Set(),
                totalRating: 0,
                count: 0,
                comments: ""
              };
            }
            periodGroups[periodKey].entries.push(entry);
            periodGroups[periodKey].totalRating += parseFloat(entry.ratings) || 0;
            periodGroups[periodKey].count += 1;

            const managerName = entry?.projectManager?.fullname || "Unknown";
            if (managerName) periodGroups[periodKey].managers.add(managerName);
            if (entry.project) periodGroups[periodKey].projects.add(entry.project);

            const managerComment = entry.comments || "";
            const separator = "\n\n\n\n———————————————————————————————\n\n\n\n";
            const formattedComment = `${managerName}:\n\n\n${managerComment}`;


            periodGroups[periodKey].comments += periodGroups[periodKey].comments
              ? `${separator}${formattedComment}`
              : formattedComment;
          });

          // Create combined entries
          const combined = Object.keys(periodGroups).map(periodKey => {
            const group = periodGroups[periodKey];
            const firstEntry = group.entries[0];

            return {
              ...firstEntry,
              ratings: parseFloat((group.totalRating / group.count).toFixed(2)),
              comments: group.comments.trim() || "No Feedback Available",
              projectManager: {
                fullname: Array.from(group.managers).join(", "),
              },
              project: Array.from(group.projects).join(", "),
              combined: true,
            };
          });

          const finalResult = [...individual, ...combined];
          setAllRatings(finalResult);
          setFilteredElements(individual);
          setShowToggle(individual.length > 1);
        } else {
          if (res.data.length === 0) {
            let arr = [firstBiweeklyObj, secondBiweeklyObj];
            setFilteredElements(arr);
            setAllRatings(arr);
            setShowToggle(false);
          } else {
            const firstPeriodData = res.data.filter(item =>
              moment(item.startDate).format("YYYY-MM-DD") === sD1
            );
            const secondPeriodData = res.data.filter(item =>
              moment(item.startDate).format("YYYY-MM-DD") === sD2
            );

            const firstPeriod = firstPeriodData.length > 0
              ? firstPeriodData
              : [firstBiweeklyObj];
            const secondPeriod = secondPeriodData.length > 0
              ? secondPeriodData
              : [secondBiweeklyObj];

            const individual = [...firstPeriod, ...secondPeriod].map(item => ({
              ...item,
              projectManager: {
                ...item.projectManager,
                fullname: item.projectManager?.fullname || 
                         (item.projectManager?.firstname && item.projectManager?.lastname 
                           ? `${item.projectManager.firstname} ${item.projectManager.lastname}` 
                           : item.projectManager?.username || "Select Project Manager")
              }
            }));
            const periodGroups = {
              first: { entries: [], managers: new Set(), projects: new Set(), totalRating: 0, count: 0, comments: "" },
              second: { entries: [], managers: new Set(), projects: new Set(), totalRating: 0, count: 0, comments: "" }
            };

            individual.forEach((entry) => {
              const periodKey = moment(entry.startDate).format("YYYY-MM-DD") === sD1 ? "first" : "second";
              const group = periodGroups[periodKey];
              
              group.entries.push(entry);
              group.totalRating += parseFloat(entry.ratings) || 0;
              group.count += 1;

              const managerName = entry?.projectManager?.fullname || "Unknown";
              if (managerName) group.managers.add(managerName);
              if (entry.project) group.projects.add(entry.project);

              const managerComment = entry.comments || "";
              const separator = "\n\n\n\n———————————————————————————————\n\n\n\n";
              const formattedComment = `${managerName}:\n\n${managerComment}`;

              group.comments += group.comments
                ? `${separator}${formattedComment}`
                : formattedComment;
            });

            const combined = [];
            if (periodGroups.first.entries.length > 0) {
              const firstEntry = periodGroups.first.entries[0];
              combined.push({
                ...firstEntry,
                ratings: parseFloat((periodGroups.first.totalRating / periodGroups.first.count).toFixed(2)),
                comments: periodGroups.first.comments.trim() || "No Feedback Available",
                projectManager: {
                  fullname: Array.from(periodGroups.first.managers).join(", "),
                },
                project: Array.from(periodGroups.first.projects).join(", "),
                combined: true,
              });
            }

            if (periodGroups.second.entries.length > 0) {
              const secondEntry = periodGroups.second.entries[0];
              combined.push({
                ...secondEntry,
                ratings: parseFloat((periodGroups.second.totalRating / periodGroups.second.count).toFixed(2)),
                comments: periodGroups.second.comments.trim() || "No Feedback Available",
                projectManager: {
                  fullname: Array.from(periodGroups.second.managers).join(", "),
                },
                project: Array.from(periodGroups.second.projects).join(", "),
                combined: true,
              });
            }

            const finalResult = [...individual, ...combined];
            setAllRatings(finalResult);
            setFilteredElements(individual);
            setShowToggle(individual.length > 1);
          }
        }

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });

    // }
  }, [startDate, endDate]);

  const handleToggleChange = (e) => {
    const isChecked = e.target.checked;
    setShowCombined(isChecked);
    if (isChecked) {
      const combinedOnly = allRatings.filter((e) => e.combined);
      setFilteredElements(combinedOnly);
    } else {
      const individualOnly = allRatings.filter((e) => !e.combined);
      setFilteredElements(individualOnly);
    }
  };

  return (
    // loading ? (
    //     <Grid sx={{ textAlignLast: "center" }} item xs={12}>
    //         <Box style={{ paddingTop: "50px", paddingBottom: "40px" }}>
    //             <CircularProgress />
    //         </Box>
    //     </Grid>) :
    //     <div
    //         className="ag-theme-alpine" // applying the grid theme
    //         style={{
    //             height: 419,
    //             width: "100%",
    //             fontFamily: "Lucida Grande",
    //         }}
    //     >
    //         <AgGridReact
    //             rowData={filteredElements}
    //             columnDefs={columnDefs}
    //             domLayout="normal"
    //             defaultColDef={{
    //                 filter: true,
    //                 width: 120,
    //                 headerClass: "custom-header",
    //             }}
    //         />
    //     </div>
    <>
      {/* {showToggle && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={showCombined}
                onChange={handleToggleChange}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                    color: 'teal',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 128, 128, 0.08)',
                    },
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: 'teal',
                  },
                }}
              />
            }
            label="Show Average Ratings"
          />
        </Box>
      )} */}

      <GenericTable
        type={"User Ratings"}
        colDefs={columnDefs}
        elements={filteredElements}
        filteredElements={filteredElements}
        setFilteredElements={setFilteredElements}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        minDate={true}
        setEndDate={setEndDate}
        loading={loading}
        displayAdd={false}
        displayHeader={true}
        showToggle={showToggle}
        showCombined={showCombined}
        onToggleChange={handleToggleChange}
      />
    </>
  );
};

export default UserScreenAppraisal;
